<template>
    <router-link to="/helex/Ayuda/Academia" class="text-decoration-none">
        <div class="p-4 bg-dark rounded h-100 d-flex flex-column position-relative card-academia">
            <!-- botón flotante -->
            <div v-b-tooltip.hover title="Ir a Academia" class="position-absolute"
                style="top: 0 !important; right: 0 !important">
                <vs-button flat icon success>
                    <i class="fas fa-paper-plane"></i>
                </vs-button>
            </div>

            <!-- título -->
            <h3 class="text-white-50 text-truncate mb-4">
                Academia
            </h3>

            <!-- contenido -->
            <div class="flex-grow-1 d-flex flex-column justify-content-center align-items-center">
                <vs-button icon circle flat>
                    <i class="fas fa-graduation-cap zoom text-primary" style="font-size: 3rem"></i>
                </vs-button>

                <p class="text-white-50 text-center mt-3 px-3">
                    Accede a tus cursos, capacitaciones y recursos de aprendizaje.
                </p>
            </div>
        </div>
    </router-link>
</template>

<script>
export default {
    name: "cardAcademia",
};
</script>

<style scoped>
.card-academia {
    transition: all 0.3s ease;
    cursor: pointer;
}

.card-academia:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.4);
}

.zoom {
    transition: transform 0.3s ease;
}

.zoom:hover {
    transform: scale(1.1);
}
</style>
